import React, { useEffect } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { IonicInput } from 'ionic-ui';
import { WalletKyc } from '../../../../../../../schemas/wallet-kyc-schema';
import {
  AutoCompleteInput,
  OptionsType,
} from '../../../../../../ui/AutoCompleteInput';
import {
  findCountry,
  findStateInCountry,
} from '../../../../../../../utils/helperFunction/findCountryAndRegion';

export default function AddressChoiceDialog() {
  const { control, watch, resetField } = useFormContext<WalletKyc>();

  // DROP DOWN OPTION FETCHERS
  const selectedCountry = watch(
    'address_choice.new_address.country'
  )?.id.trim();
  const getCountry = async (query: string): Promise<OptionsType[]> => {
    const possibleCountries = await findCountry(query);
    return possibleCountries?.map(({ name, code }) => ({
      id: code,
      icon: <span className={`fi fi-${code.toLowerCase()}`}></span>,
      name,
    }));
  };

  const getState = async (query: string): Promise<OptionsType[]> => {
    const possibleStates = await findStateInCountry(query, selectedCountry);
    return possibleStates?.map(({ name }) => ({ id: name, name })) ?? [];
  };

  useEffect(() => {
    resetField('address_choice.new_address.state');
  }, [selectedCountry]);

  return (
    <div>
      <h6 className="medium-emphasis-text font-medium">
        Confirm Store information
      </h6>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 py-4">
        <Controller
          name="address_choice.new_address.street"
          control={control}
          render={({ field, fieldState }) => (
            <div>
              <IonicInput
                {...field}
                label="Store primary address*"
                placeholder="e.g. No.3 Obasanjo street"
                hint={fieldState.error?.message ?? ''}
                hintClass={fieldState.error ? 'text-destructive' : undefined}
              />
            </div>
          )}
        />

        <Controller
          name="address_choice.new_address.street_line_2"
          control={control}
          render={({ field, fieldState }) => (
            <div>
              <IonicInput
                {...field}
                label="Store secondary address"
                placeholder="e.g. No.5 Alan street"
                hint={fieldState.error?.message ?? ''}
                hintClass={fieldState.error ? 'text-destructive' : undefined}
              />
            </div>
          )}
        />

        <Controller
          name="address_choice.new_address.country"
          control={control}
          render={({ field, fieldState }) => (
            <AutoCompleteInput
              value={field.value}
              fetchOptions={getCountry}
              onChange={(value: any) => field.onChange(value)}
              label="Country*"
              placeholder="Enter country"
              hintMsg={fieldState.error?.message}
            />
          )}
        />

        <Controller
          name="address_choice.new_address.state"
          control={control}
          render={({ field, fieldState }) => (
            <AutoCompleteInput
              value={field.value}
              fetchOptions={getState}
              onChange={(value: any) => field.onChange(value)}
              label="State*"
              placeholder="Enter state"
              hintMsg={fieldState.error?.message}
            />
          )}
        />

        <Controller
          name="address_choice.new_address.city"
          control={control}
          render={({ field, fieldState }) => (
            <div>
              <IonicInput
                {...field}
                label="City*"
                placeholder="e.g. gwagwalada"
                hint={fieldState.error?.message ?? ''}
                hintClass={fieldState.error ? 'text-destructive' : undefined}
              />
            </div>
          )}
        />

        <Controller
          name="address_choice.new_address.lga"
          control={control}
          render={({ field, fieldState }) => (
            <div>
              <IonicInput
                {...field}
                label="local government area"
                placeholder="Enter LGA of store"
                hint={fieldState.error?.message ?? ''}
                hintClass={fieldState.error ? 'text-destructive' : undefined}
              />
            </div>
          )}
        />

        <Controller
          name="address_choice.new_address.postal_code"
          control={control}
          render={({ field, fieldState }) => (
            <div>
              <IonicInput
                {...field}
                label="postal code"
                placeholder="Enter postal code"
                hint={fieldState.error?.message ?? ''}
                hintClass={fieldState.error ? 'text-destructive' : undefined}
              />
            </div>
          )}
        />
      </div>
    </div>
  );
}
